import { API_BASE } from "@vorloop/api-client-react";

/**
 * Build the WebSocket URL for an API path.
 *
 * - When `VITE_API_BASE` is set (e.g. https://api.vor.codes), strip the
 *   scheme and use `wss://api.vor.codes/...` directly.
 * - Otherwise, mirror the page's origin: same host, ws/wss based on
 *   page protocol. This is the localhost-dev case where Vite proxies
 *   /api → :4099 with WS upgrade support.
 */
export function buildWsUrl(path: string): string {
  const rel = path.startsWith("/") ? path : `/${path}`;
  if (API_BASE) {
    const wsBase = API_BASE.replace(/^https:/i, "wss:").replace(/^http:/i, "ws:");
    return `${wsBase}${rel}`;
  }
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}${rel}`;
}
